import { createApp } from 'vue';
import App from './App.vue';
import router from './router/router';
import store from './store';
import i18n from '@/plugins/i18n';



const app = createApp(App);

app.use(router);
app.use(store);
app.use(i18n);


//createApp(App).use(store).use(router).mount('#app');

app.mount('#app');
export { app };
